import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const TextFieldComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);

    const [inputValue, setInputValue] = useState(value !== undefined ? value : (options.defaultValue || options.value || ''));

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;

        if (constrains.maxLength && newValue.length > constrains.maxLength) {
            return;
        }

        if (constrains.pattern && !new RegExp(constrains.pattern).test(newValue)) {
            return;
        }

        setInputValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(newValue);
        }
    };

    return (
        <MUITextField
            label={options.label || TEXT.TextField[language]}
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            inputProps={{
                maxLength: constrains.maxLength || undefined,
                pattern: constrains.pattern || undefined,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default TextFieldComponent;
